import React, { useState, useEffect } from "react";
import { getPagosCliente } from "../../services/RegistroPagos";
import formatCurrency from "../../formatters/currency";
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import apiConfig from "../../utils/api";

const HistorialPagosCliente = () => {
  const [pagos, setPagos] = useState([]);

  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('InicioAnno')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
   

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const firstDayYear = new Date(today.getFullYear(), 0, 1);
    if(Como === 'InicioAnno') return firstDayYear;
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  const fetchPagos = async () => {
    const data = await getPagosCliente(selectedDate.toISOString(),selectedDateEnd.toISOString());
    if (data) setPagos(data);
  };

  useEffect(() => {
    fetchPagos();
  }, [selectedDate,selectedDateEnd]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  return (
    <div className="m-4 md:m-10 mt-16 p-6 bg-white rounded-3xl shadow-md">
<div className="flex flex-col md:flex-row md:items-start md:justify-between mb-6">
  {/* Título y filtros de fecha */}
  <div className="md:w-2/3">
    <h2 className="text-xl font-semibold text-gray-800 mb-2">Historial de Pagos</h2>
    <p className="text-sm text-gray-500 mb-4">
      Consulta los pagos realizados en un período específico.
    </p>

    <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="text-sm font-medium text-gray-700">Desde</label>
        <SeleccionaFecha
          selectedDate={selectedDate}
          handleDateChange={handleDateChange}
        />
      </div>

      <div>
        <label className="text-sm font-medium text-gray-700">Hasta</label>
        <SeleccionaFecha
          selectedDate={selectedDateEnd}
          handleDateChange={handleDateChangeEnd}
        />
      </div>
    </form>
  </div>

    {/* Tarjeta de información al costado derecho */}
    <div className="md:w-1/3 mt-6 md:mt-0 md:ml-4">
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 shadow-sm text-sm text-gray-700">
        <p className="font-semibold text-base mb-2">Biomap SPA</p>
        <ul className="space-y-1">
          <li>▪ Rut: 77.826.869-8</li>
          <li>▪ Banco BCI</li>
          <li>▪ Cta. cte.: 32590539</li>
          <li>▪ Aviso: <a href="mailto:reciclar@biomap.cl" className="text-blue-600 underline">reciclar@biomap.cl</a></li>
        </ul>
    {/* Botón de Pago */}
    <div className="mt-6 flex justify-center">
      <a
        href = {apiConfig.dev.API_PAGOS}
        target="_blank"
        rel="noopener noreferrer"
        className="px-4 py-2 bg-gray-200 text-gray-700 text-sm rounded-lg shadow-sm hover:bg-blue-500 hover:text-white transition-colors duration-300"
      >
        Pagar con Flow
      </a>
    </div>
      </div>
    </div>
  </div>


      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left border-t border-gray-200">
          <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              <th className="px-4 py-2">Fecha</th>
              <th className="px-4 py-2">Plan</th>
              <th className="px-4 py-2">Medio de Pago</th>
              <th className="px-4 py-2">Monto</th>
            </tr>
          </thead>
          <tbody>
            {pagos.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center py-6 text-gray-500">
                  No se encontraron pagos en este período.
                </td>
              </tr>
            ) : (
              pagos.map((pago, idx) => (
                <tr key={idx} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-2">{new Date(pago.fechaCreacion).toLocaleDateString()}</td>
                  <td className="px-4 py-2">{pago.nombrePlan}</td>
                  <td className="px-4 py-2">{pago.medioPago}</td>
                  <td className="px-4 py-2 font-semibold text-indigo-700">
                    {formatCurrency(pago.monto)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HistorialPagosCliente;